module.exports = __webpack_public_path__ + "static/215-c6d0f92dbea63597490a79df0deeeaf8.jpg";